<template>
  <b-form class="px-3 py-1 background-alternating d-relative" inline
          @mouseover="$parent.$parent.activeVariant = variantIndex">
    <div v-if="!notSaved" class="mr-2 w-20">
      <variant-list-input v-model="currentVariant.selectedOptions[0].value"
                          :index="variantIndex"
                          name="Name"
                          type="text"
                          @keyup.native="hasChange = true"
      ></variant-list-input>
    </div>
    <div v-if="!notSaved" class="mr-2 w-10" style="position: relative;">
      <variant-list-input v-model="currentVariant.price" :index="variantIndex" min="0" name="Preis"
                          type="number" @keyup.native="hasChange = true"
                          @click.native="hasChange = true"></variant-list-input>
    </div>
    <div v-if="!notSaved" class="mr-1 w-10">
      <variant-list-input v-model="currentVariant.inventoryItem.measurement.weight.value" :index="variantIndex" min="0"
                          name="Gewicht"
                          type="number" @keyup.native="hasChange = true"
                          @click.native="hasChange = true"></variant-list-input>
    </div>
    <div v-if="!notSaved" class="w-7 mr-2">
      <label v-if="variantIndex===0">&nbsp;</label>
      <b-select v-model="currentVariant.inventoryItem.measurement.weight.unit" :options="units"
                @change="hasChange = true">
      </b-select>
    </div>
    <div v-if="!notSaved" class="mr-2 w-10">
      <variant-list-input v-model="currentVariant.inventoryItem.sku" :index="variantIndex" name="SKU" type="text"
                          @keypress.native="hasChange = true"></variant-list-input>
    </div>
    <div v-if="!notSaved" class="w-15 mr-2">
      <label v-if="variantIndex===0">Exklusiv</label>
      <b-select v-model="selectedCustomer" :options="customerSelectOptions" style="max-width: 200px"
                @change="toggleReservedSuffixInTitle">
      </b-select>
    </div>
    <div v-if="!notSaved" class="w-15 mr-2">
      <label v-if="variantIndex===0">Gebinde</label>
      <b-select v-model="selectedContainer" :options="containersSelectOptions" @change="hasChange = true">
      </b-select>
    </div>
    <div class="list-action" style="position: absolute; right: 0; padding: 7px 10px; min-width: 97px">
      <b-button :disabled="inProgress || !hasChange" :variant="hasChange ? 'primary' : 'secondary'" class="mr-3"
                size="sm" @click="updateVariant"><i class="fas fa-save"></i></b-button>
      <b-button v-if="variantIndex > 0 && !notSaved" :disabled="inProgress" class="btn-sm" variant="danger"
                @click="deleteVariant"><i class="fas fa-trash"></i></b-button>
    </div>
  </b-form>
</template>

<script>
import VariantListInput from "@/pages/EditProductPage/Variants/VariantListInput";
import products from "@/api/products";
import {handleError} from "@/utils/errors";


export default {
  props: ['variant', 'variantIndex', 'productId', 'customers', 'containers'],
  components: {VariantListInput},
  data() {
    return {
      currentVariant: {...this.variant},
      loadedVariant: {...this.variant},
      selectedCustomer: 'all',
      selectedContainer: 'none',
      inProgress: false,
      hasChange: false,
      units: [
        {value: 'KILOGRAMS', text: 'kg'},
        {value: 'GRAMS', text: 'g'},
        // {value: 'OUNCES', text: 'oz'},
        // {value: 'POUNDS', text: 'lb'}
      ],
    }
  },
  created() {
    if (this.variant === undefined) {
      this.currentVariant = {...this.emptyVariant}
    }

    const customerMetafield = this.getMetafieldByKey('customers')
    try {
      this.selectedCustomer = JSON.parse(customerMetafield.value)[0]
    } catch (ValueError) {
      this.selectedCustomer = 'all'
    }

    const containerMetafield = this.getMetafieldByKey('container')
    if (containerMetafield !== undefined) {
      this.selectedContainer = containerMetafield.value
    }
  },
  computed: {
    customerSelectOptions() {
      return [
        {value: "all", text: "Für alle"},
      ].concat(
          this.customers.map(customer => ({value: customer.id, text: customer.displayName}))
      )
    },
    containersSelectOptions() {
      const defaultContainer = {
        value: 'none',
        text: "Kein Gebinde"
      }

      if (this.containers !== null) {
        return [
          defaultContainer
        ].concat(
            this.containers.variants.map(variant => ({value: variant.id, text: variant.title}))
        )
      } else {
        return [defaultContainer]
      }

    },
    customersMetafield() {
      let customersMetafield = {};
      const metafieldDefinition = {
        namespace: 'reservations',
        key: 'customers',
        type: 'json'
      }
      try {
        customersMetafield = this.currentVariant.metafields.find(field => field.key === 'customers')
      } catch {
        customersMetafield = metafieldDefinition;
      }
      if (customersMetafield === undefined) {
        customersMetafield = metafieldDefinition
      }
      customersMetafield.value = JSON.stringify([this.selectedCustomer])
      return customersMetafield
    },
    containerMetafield() {
      const metafieldDefinition = {
        namespace: 'contaners',
        key: 'container',
        type: 'variant_reference'
      }
      let containerMetafield = {};
      try {
        containerMetafield = this.currentVariant.metafields.find(field => field.key === 'container')
      } catch {
        containerMetafield = metafieldDefinition;
      }
      if (containerMetafield === undefined) {
        containerMetafield = metafieldDefinition
      }
      containerMetafield.value = this.selectedContainer
      return containerMetafield

    },
    unitsMapping() {
      return this.units.reduce(
          (output, mapping) => {
            output[mapping.value] = mapping.text
            return output
          }, {})
    },
    notSaved() {
      return this.currentVariant.id === undefined
    }
  },
  methods: {
    getMetafieldByKey(key) {
      return this.currentVariant.metafields.find(field => field.key === key)
    },
    getVariantRequestPayload() {
      let payload = {
        ...this.currentVariant,
        optionValues: this.currentVariant.selectedOptions.map(o => ({optionName: 'Title', name: o.value})),
        metafields: [
          this.customersMetafield,
        ]
      }
      if (this.containerMetafield.value !== 'none') {
        payload.metafields.push(this.containerMetafield)
      }
      return payload
    },
    updateVariant() {
      this.inProgress = true;
      products.putVariant(
          this.productId,
          this.currentVariant.id,
          this.getVariantRequestPayload()
      ).then(response => {
        this.currentVariant = response.data
        this.$emit('variant-updated', this.currentVariant)
      }).finally(
          () => {
            this.inProgress = false
            this.hasChange = false
          }
      ).catch(
          () => handleError({vm: this, error: 'Failed to update variant'})
      )
    },
    deleteVariant() {
      this.inProgress = true;
      products.removeVariant(this.productId, this.currentVariant.id).then(
          () => {
            this.$emit('variant-deleted', this.currentVariant.id)
          }
      ).finally(() => {
        this.inProgress = false
      })
    },
    toggleReservedSuffixInTitle() {
      const t = this.currentVariant.selectedOptions[0].value.replace(/ reserviert.+$/, '');
      this.hasChange = true
      if (this.selectedCustomer !== 'all') {
        const customer = this.customers.find(customer => customer.id === this.selectedCustomer)
        this.currentVariant.selectedOptions[0].value = t + ' reserviert für ' + customer.displayName
      } else {
        this.currentVariant.selectedOptions[0].value = t
      }
    }
  }
}
</script>

<style lang="scss">
.w-5 {
  width: 5% !important;
}

.w-7 {
  width: 6.5% !important;
}

.w-10 {
  width: 9% !important;
}

.w-20 {
  width: 18% !important;
}

.w-30 {
  width: 27% !important;
}

.variant-list .list-action {
  background: #fff;
  width: 98px;
  border-left: 1px solid lightgray;
}

.background-alternating:nth-last-of-type(2n) {
  background: #F0F0F0;

  .list-action {
    background: #F0F0F0;
  }
}

.variant-list .form-inline label, .inventory-list .form-inline label {
  justify-content: flex-start;
  align-items: center;
  font-weight: bold;
}

.variant-list form:first-of-type .list-action, .inventory-list:first-of-type form button {
  margin-top: 23px;
}
</style>
